/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-11 09:05:20
 * @LastEditTime: 2020-09-27 09:40:08
 * @Description: 储罐借用store
 */
import {
    getTankRentalByID,
    getTankRentalList,
    updateTankRental,
    deleteTankRental,
    createTankRental
} from '@/api/tankRental'
import Vue from 'vue'

const state = {
    tankRentalList: [],
    totalCounts: 0
}

const actions = {
    async getTankRentalListAction({
        commit
    }, payload) {
        try {
            const tankRentalList = await getTankRentalList(payload);
            commit('SETTANKRENTALLIST', tankRentalList.data)
        } catch (error) {
            throw error.message
        }
    },
    async getTankRentalByIDAction({
        commit
    }, payload) {
        try {
            const tankRental = await getTankRentalByID(payload)
            return tankRental.data
        } catch (error) {
            throw error.message
        }
    },
    async createTankRentalAction({
        commit
    }, payload) {
        try {
            const tankRental = await createTankRental(payload);
            commit('ADDTANKRENTAL', tankRental.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateTankRentalAction({
        commit
    }, payload) {
        try {
            const tankRental = await updateTankRental(payload.id, payload.data)
            commit('UPDATETANKRENTAL', tankRental.data)
        } catch (error) {
            throw error.message
        }
    },
    async deleteTankRentalAction({
        commit
    }, payload) {
        try {
            await deleteTankRental(payload)
            commit('DELETETANKRENTAL', payload)
        } catch (error) {
            throw error.message
        }
    }
}

const mutations = {
    SETTANKRENTALLIST(state, payload) {
        state.tankRentalList = payload.tankRentalList;
        state.totalCounts = payload.totalCounts
    },
    ADDTANKRENTAL(state, tankRental) {
        state.tankRentalList.unshift(tankRental)
        state.totalCounts++
    },
    DELETETANKRENTAL(state, id) {
        state.tankRentalList = state.tankRentalList.filter(e => e._id !== id)
        state.totalCounts--
    },
    UPDATETANKRENTAL(state, tankRental) {
        Vue.set(state.tankRentalList, state.tankRentalList.findIndex(x => x._id === tankRental._id), tankRental)
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}